import { constants } from '../constants';

export interface QRVMessage {
  type: 'CLOSE_QRV_MODAL';
  registrationComplete: boolean;
  reason: string;
  errorCode?: 'SEAMLESS_AUTH_FAILED' | 'USER_REGISTRATION_FAILED';
  timestamp: number;
}

export interface HandlerOptions {
  iframeOrigin: string;
  onSuccess: (msg: QRVMessage) => void;
  onFailure: (msg: QRVMessage) => void;
  onClose: (msg: QRVMessage) => void;
  debug?: boolean;
}

function isQRVMessage(data: unknown): data is QRVMessage {
  if (!data || typeof data !== 'object') return false;

  const msg = data as QRVMessage;

  return (
    msg.type === 'CLOSE_QRV_MODAL' &&
    typeof msg.registrationComplete === 'boolean' &&
    typeof msg.reason === 'string' &&
    typeof msg.timestamp === 'number'
  );
}

export function initQRVMessageListener(options: HandlerOptions) {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const { iframeOrigin, onSuccess, onFailure, onClose, debug } = options;

  const handler = (event: MessageEvent) => {
    if (event.origin !== iframeOrigin) return;

    if (!isQRVMessage(event.data)) {
      debug && console.warn('[QRV] Invalid message received', event.data);
      return;
    }

    const qrvPortalEventData = event.data;

    debug && console.log('[QRV] Message received:', qrvPortalEventData);

    if (qrvPortalEventData.registrationComplete) {
      debug && console.log('[QRV] Registration successful, ', qrvPortalEventData);
      onSuccess(qrvPortalEventData);
      return;
    }

    switch (qrvPortalEventData.errorCode) {
      case 'SEAMLESS_AUTH_FAILED':
        debug && console.log('[QRV] SEAMLESS_AUTH failed, ', qrvPortalEventData);
        onFailure(qrvPortalEventData);
        return;

      case 'USER_REGISTRATION_FAILED':
        debug && console.log('[QRV] USER_REGISTRATION failed, ', qrvPortalEventData);
        onClose(qrvPortalEventData);
        return;

      default:
        debug && console.warn('[QRV] Unknown failure state received', qrvPortalEventData);
        onClose(qrvPortalEventData);
    }
  };

  window.addEventListener(constants.MESSAGE_EVENT, handler);

  return () => {
    window.removeEventListener(constants.MESSAGE_EVENT, handler);
  };
}
